import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import { capturePartnerActivation } from "@/lib/partnerApi";
import PartnerActivationPage from "@/pages/partner/PartnerActivationPage";
export const Route = createFileRoute("/partner_/activate")({
  beforeLoad: () => {
    if (typeof window !== "undefined") capturePartnerActivation();
  },
  head: () =>
    pageHead(
      "Partner Activate",
      "Secure Partner account access.",
      "/partner/activate",
      true,
    ),
  component: PartnerActivationPage,
});
